// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/map-pin.js';

import { paths } from '../generated/map-pin';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('map-pin', Original, paths);
